import { render, staticRenderFns } from "./VacationConfirmWaitingDayLegend.vue?vue&type=template&id=a5f6ae9a&"
import script from "./VacationConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f6ae9a')) {
      api.createRecord('a5f6ae9a', component.options)
    } else {
      api.reload('a5f6ae9a', component.options)
    }
    module.hot.accept("./VacationConfirmWaitingDayLegend.vue?vue&type=template&id=a5f6ae9a&", function () {
      api.rerender('a5f6ae9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/VacationConfirmWaitingDayLegend.vue"
export default component.exports